import { checkApiStatus } from ".";
import { globalPostFileUpdateService, globalPostFileUploadService } from "./globalApiServices";

const storeApiResponse = (moduleName, slug, response) => {
  let storedData = sessionStorage.getItem("apiResponses");
  storedData = storedData ? JSON.parse(storedData) : {};

  if (response?.successful_files?.length === 0) {
    if (!storedData[moduleName]) storedData[moduleName] = {};
    storedData[moduleName][slug] = response;
  } else {
    if (storedData[moduleName]) {
      storedData[moduleName][slug] = null;
    }
  }

  sessionStorage.setItem("apiResponses", JSON.stringify(storedData));
};

export const getApiResponse = (moduleName, slug) => {
  let storedData = sessionStorage.getItem("apiResponses");
  if (!storedData) return null;
  storedData = JSON.parse(storedData);
  const moduleData = storedData[moduleName];
  if (!moduleData) return null;
  const entries = Object.entries(moduleData).map(([key, value]) => ({
    slug: key,
    data: value
  }));
  const found = entries.find(entry => entry.slug === slug);
  return found ? found.data : null;
};

export const formatBytes = (bytes) => {
  if (!bytes || isNaN(bytes)) return "0 MB";
  const kb = 1024, mb = kb * 1024, gb = mb * 1024, tb = gb * 1024;

  if (bytes >= tb) return (bytes / tb).toFixed(2) + " TB";
  if (bytes >= gb) return (bytes / gb).toFixed(2) + " GB";
  if (bytes >= mb) return (bytes / mb).toFixed(2) + " MB";
  if (bytes >= kb) return (bytes / kb).toFixed(2) + " KB";
  return bytes + " Bytes";
};

const fileUpload = async ({
  attachments = [],
  module_name,
  slug,
  onProgress,     
  onSuccess,       
  onError,        
  onStart,         
  onComplete,
  query      
}) => {
  if (!attachments.length) return;
  const payload = {
    files: attachments.map(file => ({
      file_name: file.name,
      file_size: file.size,
      file_type: file.name.split(".").pop().toLowerCase()
    }))
  };

  try {
    if (onStart) onStart();
    const progressRefs = { current: [] };
    const queryString=new URLSearchParams(query).toString();
    const response = await globalPostFileUploadService(`/get-pre-signed-url/${module_name}/${slug}${queryString?`?${queryString}`:''}`, payload);

    if (checkApiStatus(response) && response?.data?.data?.successful_files?.length>0) {
      if (onProgress) {
        storeApiResponse(module_name,slug,response?.data?.data)
        onProgress({ progressRefs, attachments ,response});
      }
      const uploadPromises = response?.data?.data?.successful_files.map((fileData, index) => {
        const file = attachments[index];
       return globalPostFileUpdateService(fileData.pre_signed_url, file, (progress) => {
          if (typeof progressRefs?.current?.[index] === "function") {
             progressRefs.current[index](progress);
            }
          }).then(() => {
          return globalPostFileUploadService(
            `/update-attachment-metadata/${module_name}/${slug}`,
            { attachment_slug: fileData.attachment_slug, status: { value: 1 } }
          );
        });
      });

      await Promise.all(uploadPromises);

      if (onSuccess) onSuccess((response?.data?.message || "Attachments Uploaded Successfully."));
      return response?.data?.data?.successful_files?.[0]?.attachment_slug || null;
    } else {
      throw new Error(response?.data?.message || "Something went wrong");
    }
  } catch (err) {
    if (onError) onError(err);
  } finally {
    if (onComplete) onComplete();
  }
};

export default fileUpload;
